<template>
  <div>
    <el-alert
      title="草稿可预留库存。发货会生成并审核发货出库单，有预留则消耗预留；反发货回冲库存并删除该出库单，发货单回到草稿。批次可手填。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.deliveryCode" clearable placeholder="发货单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.customerName" clearable placeholder="客户" style="width:150px" @keyup.enter.native="search" />
      <el-select v-model="query.deliveryState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已发货" value="01" />
        <el-option label="已完成" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="deliveryCode" label="发货单号" width="180" />
      <el-table-column prop="customerName" label="客户" min-width="140" show-overflow-tooltip />
      <el-table-column prop="orderCode" label="关联工单" width="150" />
      <el-table-column prop="deliveryDate" label="发货日期" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="stateType(row.deliveryState)">{{ stateLabel(row.deliveryState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openView(row.deliveryId)">查看</el-button>
          <el-button type="text" :disabled="row.deliveryState !== '00'" @click="openEdit(row.deliveryId)">修改</el-button>
          <el-button type="text" :disabled="row.deliveryState !== '00'" @click="reserveRow(row.deliveryId)">预留</el-button>
          <el-button type="text" :disabled="row.deliveryState !== '00'" @click="releaseRow(row.deliveryId)">释放预留</el-button>
          <el-button type="text" :disabled="row.deliveryState !== '00'" @click="shipRow(row.deliveryId)">发货</el-button>
          <el-button type="text" :disabled="row.deliveryState !== '01' && row.deliveryState !== '02'" @click="unshipRow(row.deliveryId)">反发货</el-button>
          <el-button type="text" :disabled="row.deliveryState !== '01'" @click="completeRow(row.deliveryId)">完成</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.deliveryState !== '00'" @click="onDelete(row.deliveryId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="1080px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="发货单号"><el-input v-model="form.deliveryCode" placeholder="留空自动生成" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="发货日期">
              <el-date-picker v-model="form.deliveryDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户">
              <el-select v-model="form.customerId" filterable clearable placeholder="请选择客户" style="width:100%" @change="onCustomer">
                <el-option v-for="c in companies" :key="c.companyId" :label="(c.companyNumber ? c.companyNumber + ' / ' : '') + c.companyName" :value="c.companyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产工单">
              <el-select v-model="form.orderId" filterable clearable placeholder="可选" style="width:100%">
                <el-option v-for="o in orders" :key="o.orderId" :label="o.orderCode + ' / ' + (o.orderName || '')" :value="o.orderId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
        <el-button v-if="!readonly" type="primary" size="mini" @click="addLine">添加明细</el-button>
        <el-table :data="form.lineList" border size="small" style="margin-top:8px">
          <el-table-column label="产品" min-width="220">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ productText(row) }}</span>
              <el-select v-else v-model="row.productId" filterable size="mini" style="width:100%">
                <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="仓库" width="160">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.wareHouseName || '-' }}</span>
              <el-select v-else v-model="row.wareHouseId" filterable size="mini" placeholder="选择仓库" style="width:100%">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="批次" width="120">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.batchNo || '-' }}</span>
              <el-input v-else v-model="row.batchNo" size="mini" placeholder="可选" />
            </template>
          </el-table-column>
          <el-table-column label="数量" width="130">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.quantity }}</span>
              <el-input-number v-else v-model="row.quantity" :min="0" :precision="5" size="mini" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="{ $index }">
              <el-button type="text" size="mini" @click="form.lineList.splice($index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listDelivery, getDelivery, saveDelivery, updateDelivery, deleteDelivery,
  reserveDelivery, releaseDeliveryReserve, shipDelivery, unshipDelivery, completeDelivery
} from '../../api/delivery'
import { selectCompany } from '../../api/staff'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectProduct } from '../../api/product'
import { selectEnabledWareHouse } from '../../api/warehouse'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { deliveryCode: '', customerName: '', deliveryState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false, readonly: false,
      form: {
        deliveryId: '', deliveryCode: '', orderId: '', customerId: '', customerName: '',
        deliveryDate: null, remark: '', version: 0,
        lineList: [{ productId: '', wareHouseId: '', batchNo: '', quantity: 1 }]
      },
      companies: [], orders: [], products: [], warehouses: []
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看发货单'
      return this.form.deliveryId ? '修改发货单' : '新增发货单'
    }
  },
  created() {
    this.load()
    selectCompany().then(res => { this.companies = res.data || [] }).catch(() => {})
    selectProductionOrder().then(res => { this.orders = res.data || [] }).catch(() => {})
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
  },
  methods: {
    stateLabel(s) { return { '00': '草稿', '01': '已发货', '02': '已完成' }[s] || s },
    stateType(s) { return { '00': 'info', '01': 'warning', '02': 'success' }[s] || 'info' },
    emptyForm() {
      return {
        deliveryId: '', deliveryCode: '', orderId: '', customerId: '', customerName: '',
        deliveryDate: null, remark: '', version: 0, lineList: [this.emptyLine()]
      }
    },
    emptyLine() { return { productId: '', wareHouseId: '', batchNo: '', quantity: 1 } },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listDelivery({
        currentPage: this.page, pageSize: this.pageSize,
        deliveryCode: this.query.deliveryCode,
        customerName: this.query.customerName,
        deliveryState: this.query.deliveryState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    onCustomer(id) {
      const c = this.companies.find(i => i.companyId === id)
      this.form.customerName = c ? c.companyName : ''
    },
    addLine() { this.form.lineList.push(this.emptyLine()) },
    productText(row) {
      const number = row.productNumber || ''
      const name = row.productName || ''
      if (number && name) return number + ' / ' + name
      return number || name || '-'
    },
    openView(id) {
      this.readonly = true
      this.loadForm(id)
    },
    openEdit(id) {
      this.readonly = false
      if (!id) {
        this.form = this.emptyForm()
        this.visible = true
        return
      }
      this.loadForm(id)
    },
    loadForm(id) {
      getDelivery(id).then(res => {
        const d = res.data || {}
        this.form = {
          deliveryId: d.deliveryId,
          deliveryCode: d.deliveryCode,
          orderId: d.orderId || '',
          customerId: d.customerId || '',
          customerName: d.customerName || '',
          deliveryDate: d.deliveryDate,
          remark: d.remark,
          version: d.version,
          lineList: (d.lineList && d.lineList.length) ? d.lineList.map(l => ({
            productId: l.productId,
            productNumber: l.productNumber,
            productName: l.productName,
            wareHouseId: l.wareHouseId,
            wareHouseName: l.wareHouseName,
            batchNo: l.batchNo,
            quantity: Number(l.quantity)
          })) : [this.emptyLine()]
        }
        this.visible = true
      })
    },
    submit() {
      if (this.form.customerId) this.onCustomer(this.form.customerId)
      const lines = (this.form.lineList || []).filter(l => l.productId && Number(l.quantity) > 0)
      if (!lines.length) { this.$message.warning('请添加发货明细'); return }
      if (lines.some(l => !l.wareHouseId)) { this.$message.warning('请选择发货仓库'); return }
      this.saving = true
      const payload = { ...this.form, lineList: lines }
      const req = this.form.deliveryId ? updateDelivery(payload) : saveDelivery(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    reserveRow(id) {
      this.$confirm('确认预留库存（扣减可用）?', '提示', { type: 'warning' }).then(() => {
        reserveDelivery(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    releaseRow(id) {
      this.$confirm('确认释放预留?', '提示', { type: 'warning' }).then(() => {
        releaseDeliveryReserve(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    shipRow(id) {
      this.$confirm('确认发货?', '提示', { type: 'warning' }).then(() => {
        shipDelivery(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    unshipRow(id) {
      this.$confirm('确认反发货？将回冲库存并删除发货出库单。', '提示', { type: 'warning' }).then(() => {
        unshipDelivery(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    completeRow(id) {
      completeDelivery(id).then(() => { this.$message.success('操作成功'); this.load() })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteDelivery([id]).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
